import { render, staticRenderFns } from "./OtherEquipmentElectricityMeterForm.vue?vue&type=template&id=5136ef64"
import script from "./OtherEquipmentElectricityMeterForm.vue?vue&type=script&lang=ts"
export * from "./OtherEquipmentElectricityMeterForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports